import { Box } from '@mui/material'
import { ImgHTMLAttributes, useEffect } from 'react'

import { Maybe, ResourceFragment } from '@/clients/utoniq-core/schema'
import { TheoPlayerImageView } from '@/components/organisms/resourcePlayer/TheoPlayerView'
import { useDRMPlayer } from '@/core/resources/useDRMPlayer'

/**
 * @description DRMWallpaperPlayer
 * カスタムプロフィールでDRM設定されている背景画像として表示する
 */

type Props = {
  resource: Maybe<ResourceFragment> | undefined
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'resource'>

export const DRMWallpaperPlayer = ({ resource, ...imageProps }: Props) => {
  const { ref, player, accessToken } = useDRMPlayer({
    source: {
      dashUri: resource?.dashUri || '',
      hlsUri: resource?.hlsUri || '',
    },
    opts: {
      mutedAutoplay: 'all',
    },
  })

  useEffect(() => {
    if (player && accessToken) player.play()
  }, [accessToken])

  if (!accessToken || !resource) return null

  return (
    <Box
      sx={{
        width: imageProps?.width,
        maxWidth: 600,
        margin: 'auto',
        minHeight: 'fit-content',
        height: '100%',
        display: 'grid',
        placeItems: 'start center',
        '& .vjs-loading-spinner': {
          display: 'none!important',
        },
      }}
    >
      <div>
        <TheoPlayerImageView ref={ref} playable={!!player?.duration} />
      </div>
    </Box>
  )
}
